import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";
import { FormInput, FormInputAssignedAttribute, FormInputTypes } from "redux/reducers/models/formInput";

const apiVersion = "2024-04";
const adminType = "facility-admin";
const baseUrl = "/" + apiVersion + "/" + adminType + "/client/form/input";

type GetFormInputParams = { form_id?: number };

export type PostFormInputParams = {
  form_id: number;
  label: string;
  help_text: string;
  type: FormInputTypes;
  required?: boolean; // backend defaults to true if not given
};

export type PutFormInputParams = {
  input_id: number;
  label?: string;
  help_text?: string;
  type?: FormInputTypes;
  values?: string[];
  assigned_attribute: FormInputAssignedAttribute;
  required?: boolean;
};

type DeleteFormInputParams = { id: number };

export type PutFormInputPosition = {
  id: number;
  row: number;
  column: number;
};

type PutFormInputPositionParams = {
  inputs: PutFormInputPosition[];
};

// GET Forms
export async function GetFormInput(params: GetFormInputParams, useGlobalLoader = true, token?: CancelToken) {
  return await APIGet<FormInput[]>(baseUrl, params, useGlobalLoader, token);
}

// POST Form
export async function PostFormInput(params: PostFormInputParams, useGlobalLoader = true) {
  return await APIPost<FormInput>(baseUrl, params, useGlobalLoader);
}

// PUT Forms
export async function PutFormInput(params: PutFormInputParams, useGlobalLoader = true) {
  return await APIPut<FormInput>(baseUrl, params, useGlobalLoader);
}

// PUT Forms
export async function DeleteFormInput(params: DeleteFormInputParams, useGlobalLoader = true) {
  return await APIDelete(baseUrl, params, useGlobalLoader);
}

export async function PutFormInputPositions(params: PutFormInputPositionParams, useGlobalLoader = true) {
  return await APIPut(baseUrl + "/position", params, useGlobalLoader);
}
